import { NgModule } from '@angular/core';
import { SanitizeHtmlPipe } from '../helpers/sanitize-html-pipe';
import { TaskProgressModalComponent } from './components';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {HtmlModalComponent} from './components/html-modal/html-modal.component';
import {UserHtmlComponent} from './components/user-html/user-html.component';
import { AiPromptComponent } from './components/ai-prompt/ai-prompt.component';

const exportedHelpers = [
  SanitizeHtmlPipe
];

const exportedComponents = [
  UserHtmlComponent,
  AiPromptComponent
];

const exportedModals = [
  TaskProgressModalComponent,
  HtmlModalComponent
];

@NgModule({
  declarations: [
    ...exportedHelpers,
    ...exportedComponents,
    ...exportedModals
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule
  ],
  exports: [
    ...exportedHelpers,
    ...exportedComponents,
    ...exportedModals
  ],
  entryComponents: [
    ...exportedModals
  ]
})
export class SharedModule {
}
